module.exports = __webpack_public_path__ + "static/media/acquire-item.e582d296.wav";